// extracted by mini-css-extract-plugin
export var heroImage = "_ch-1";
export var modal = "_ch-0";